import { useQuery } from '@tanstack/react-query';
import userService, { getCurrentUser } from '../../../../services/userService';

export const useLoggedinUser = () => {
    // Check if token exists in localStorage
    const token = localStorage.getItem('token');
    
    return useQuery({
        queryKey: ['loggedinUser'],
        queryFn: getCurrentUser,
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
        enabled: !!token, // Only run the query if token exists
        retry: false, // Don't retry if the query fails
    });
};

export const useStoreUsers = (store_id: string) => {
    return useQuery({
        queryKey: ['store-users', store_id],
        queryFn: () => userService.listStoreUsers(store_id),
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
    });
}; 